import { Component, Input } from '@angular/core';

@Component({
    selector: 'cl-status-indicator-list',
    templateUrl: './status-indicator-list.component.html',
    styleUrls: ['./status-indicator-list.component.scss']
})
export class StatusIndicatorListComponent {
    static $name: string = 'clStatusIndicatorList';

    @Input() statusIndicators: CASLink.Device.Ui.ViewModel.Modules.StatusIndicator[];

    constructor() {
    }

}
